import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SellerCard from '@fiverr-private/seller_card';
import PortfolioShowcase from '@fiverr-private/portfolio_showcase';
import FiverrLearn from '@fiverr-private/fiverr_learn';
import ProVerified from '@fiverr-private/pro_verified';
import '@fiverr-private/seller_card/dist/index.css';
import '@fiverr-private/portfolio_showcase/dist/index.css';
import '@fiverr-private/fiverr_learn/dist/index.css';
import '@fiverr-private/pro_verified/dist/index.css';
import WithImpressions from '../WithImpressions';
import SellerProfile from './SellerProfile';
import ScrollTo from './scrollTo';
import { biHelper } from './biHelper';

import './index.scss';

export default function InfoPanel({
    sellerCard, proSubCategories, portfolioProjects,
    fiverrLearnCourses, sellerProfile, skillTests,
    onPortfolioClick, scrollComponents, pageCtxId,
    currentUserNumberedId: buyerId
}) {
    const hasPortfolioProjects = !!portfolioProjects.portfolioProjectsThumbs.length;
    const { id: sellerId, is_pro: isPro } = sellerCard.user;

    let aboutRef;
    let position = 0;

    const baseBiData = {
        sellerId,
        buyerId,
        pageCtxId
    };

    isPro && position++;
    const pro_skills_impression = biHelper({
        ...baseBiData,
        position,
        data: proSubCategories,
        group: 'seller_card_fiverr_pro_skills_verified_impression'
    });

    position++; // increase value for the seller card

    hasPortfolioProjects && position++;
    const my_protfolio_impression = biHelper({
        ...baseBiData,
        position,
        group: 'seller_card_my_protfolio_impression'
    });

    !_.isEmpty(fiverrLearnCourses) && position++;
    const fiverr_learn_impression = biHelper({
        ...baseBiData,
        position,
        data: fiverrLearnCourses,
        group: 'seller_card_fiverr_learn_impression'
    });

    const campainLinkParams = `referrer=seller_card&ref_ctx_id=${pageCtxId}`;

    return (
        <div className="info-column">
            {isPro &&
                <WithImpressions pageCtxId={pageCtxId} value={pro_skills_impression}>
                    <ProVerified linkParams={campainLinkParams} pro_sub_categories={proSubCategories}/>
                </WithImpressions>}

            <SellerCard {...sellerCard}/>

            {scrollComponents &&
                <ScrollTo scrollComponents={scrollComponents}
                    aboutScrollFunc={() => aboutRef.scrollIntoView({ block: 'start', behavior: 'smooth' })}/>}

            <div ref={(ref) => (aboutRef = ref)}/>

            {hasPortfolioProjects &&
                <WithImpressions pageCtxId={pageCtxId} value={my_protfolio_impression}>
                    <PortfolioShowcase {...portfolioProjects} onClick={onPortfolioClick}/>
                </WithImpressions>}

            {!_.isEmpty(fiverrLearnCourses) &&
                <WithImpressions pageCtxId={pageCtxId} value={fiverr_learn_impression}>
                    <FiverrLearn courses={fiverrLearnCourses} selfview={false}/>
                </WithImpressions>}

            <SellerProfile {...sellerProfile}
                skillTests={skillTests}
                biData={{...baseBiData, initialCounter: position}}/>
        </div>
    );
}

InfoPanel.propTypes = {
    sellerCard: PropTypes.object,
    portfolioProjects: PropTypes.object,
    fiverrLearnCourses: PropTypes.array,
    proSubCategories: PropTypes.array,
    sellerProfile: PropTypes.object,
    onPortfolioClick: PropTypes.func,
    scrollComponents: PropTypes.array,
    pageCtxId: PropTypes.string
};

InfoPanel.defaultProps = {
    sellerCard: {},
    proSubCategories: [],
    portfolioProjects: {},
    fiverrLearnCourses: [],
    sellerProfile: {},
    pageCtxId: ''
};
